// 电商管理列表页 需要跳转的链接
export const enterShop = (shopId: string) => `https://www.kuaizhan.com/shop-office/shops/${shopId}/myshop`;
export const createShop = (siteId: string) => `https://www.kuaizhan.com/shop-office/sites/${siteId}/wshop-create`;
export const manageOrders = (shopId: string) => `https://www.kuaizhan.com/shop-office/shops/${shopId}/order`;
export const manageGoods = (shopId: string) => `https://www.kuaizhan.com/shop-office/shops/${shopId}/items/list`;

// 工作台各服务进入后台链接
export const SITE_LIST = '/v3/site/';
export const VOTE_LIST = '/vote/backend.html#/list/pages/0';
export const WEAPP_LIST = '/mp/apps';
export const KUAIKEDUO_SHOP_LIST = '//kuaikeduo.kuaizhan.com/v1/shop/list';
export const OFFICIAL_ACCOUNT_LIST = '/v4/official-accounts';
export const CHANGYAN_BACK = 'https://changyan.kuaizhan.com/overview';

// 升级权益
// 站点、公众号
export const SITE_UPGRADE = '/v3/homepage/pricing?type=site';
// 畅言
export const CHANGYAN_UPGRADE = 'https://changyan.kuaizhan.com/packages-intro';
// 投票
export const VOTE_UPGRADE = '/v3/homepage/pricing?type=vote';
// 小程序
export const WEAPP_UPGRADE = '/v3/homepage/pricing?type=weapp';

